import TitlePage from 'common/components/title-page.component';
import { OrderTranscription } from 'config/constants/transcription.constant';
import React, { useEffect } from 'react';
import { Purchase } from 'store/models/order.model';
import { User } from 'store/models/user.model';
import PurchaseDetails from '../purchase-details.component';
import { useDispatch } from 'react-redux';
import { CatalogSlice } from 'store/slices/catalog.slice';
import { OrderSlice } from 'store/slices/order.slice';

type SuccessPaymentProps = {
  user: User;
  entryCode: string | null;
  purchase: Purchase;
};

const SuccessPayment: React.FC<SuccessPaymentProps> = ({ user, entryCode, purchase }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CatalogSlice.resetCatalogStore());
    dispatch(OrderSlice.resetOrderStore());
  }, []);

  return (
    <React.Fragment>
      <TitlePage text={OrderTranscription.PURCHASE_SUCCESSFUL} subTitle={entryCode ?? ''} withLine />
      <PurchaseDetails purchase={purchase} user={user} withNextSteps />
    </React.Fragment>
  );
};

export default SuccessPayment;
